import { FC, useState } from 'react'
import isNil from 'lodash.isnil'

import {
  SidePanelHeader,
  SidePanelObject,
  SidePanelElementProps,
} from '@clara/layout-next'
import { Translation } from '@clara/locale'
import { AsyncState, useAsyncFn, useEffectOnce } from '@clara/hooks'

import { OPERATION_COUNTRY } from '@/config/env'

import { BankInfoResponse, UserInfoResponse } from '../../api/bank-info'
import { MxBankInfoForm } from './mx/form'
import { BrBankInfoSidepanel } from './br/sidepanel'
import { CoBankInfoForm } from './co/form'
import { getBanksService } from '../../api/get-bank-name'

type Props = {
  getBankInfo: () => Promise<BankInfoResponse>
  bankInfo?: BankInfoResponse
  userInfoResponse?: AsyncState<UserInfoResponse>
  isManagerOrCompanyOwner?: boolean
}

const form: { [key: string]: FC<any> } = {
  MX: MxBankInfoForm,
  BR: BrBankInfoSidepanel,
  CO: CoBankInfoForm,
}

const COUNTRY = OPERATION_COUNTRY

const BankInfoSidePanel: FC<SidePanelElementProps & Props> = ({
  getBankInfo,
  bankInfo,
  userInfoResponse,
  isManagerOrCompanyOwner,
}) => {
  const [isEditing, setIsEditing] = useState(isNil(userInfoResponse?.value))

  const [banksResponse, getBanks] = useAsyncFn(async () => {
    return await getBanksService({ countryCode: OPERATION_COUNTRY })
  }, [])

  useEffectOnce(() => {
    getBanks()
  })

  return form[COUNTRY]
    ? form[COUNTRY]({
        getBankInfo,
        bankInfo,
        userInfoResponse,
        isManagerOrCompanyOwner,
        isEditing,
        setIsEditing,
        banksResponse,
      })
    : null
}

export const getBankInfoSidePanel = ({
  getBankInfo,
  bankInfo,
  userInfoResponse,
  isManagerOrCompanyOwner,
}: Props) => {
  const isBr = COUNTRY === 'BR'
  const title = `bankinfo.sidepanel${isBr ? '.br.' : '.'}title`
  return [
    {
      children: [
        {
          element: (
            <BankInfoSidePanel
              getBankInfo={getBankInfo}
              bankInfo={bankInfo}
              userInfoResponse={userInfoResponse}
              isManagerOrCompanyOwner={isManagerOrCompanyOwner}
            />
          ),
          header: (
            <Translation ns="reimbursements">
              {(t) => <SidePanelHeader headline={t(title)} />}
            </Translation>
          ),
        },
      ],
    },
  ] as SidePanelObject[]
}
